import defaultSearchConfiguration from './default-search-configuration';
import './page/topdata-contact-login-list';
import './page/topdata-contact-login-detail';
import './page/topdata-contact-login-detail-details';

const { Module } = Shopware;

Module.register('topdata-contact-login-list', {
    type: 'plugin',
    name: 'TopdataContactLoginSW6.contactList.module.name',
    title: 'TopdataContactLoginSW6.contactList.module.title',
    description: 'TopdataContactLoginSW6.contactList.module.description',
    color: '#37d046',
    icon: 'regular:user',

    routePrefixName: 'topdata.contact.login',
    routePrefixPath: 'topdata/contact/login',

    entity: 'tdcl_customer_contact',

    routes: {
        list: {
            component: 'topdata-contact-login-list',
            path: 'list',
        },
        detail: {
            component: 'topdata-contact-login-detail',
            path: 'detail/:id',
            redirect: {
                name: 'topdata.contact.login.detail.details',
            },
            children: {
                details: {
                    component: 'topdata-contact-login-detail-details',
                    path: 'details',
                    meta: {
                        parentPath: 'topdata.contact.login.list',
                        privilege: 'customer.viewer',
                    },
                },
            },
            props: {
                default(route) {
                    return { contactId: route.params.id.toLowerCase() };
                },
            },
            meta: {
                parentPath: 'topdata.contact.login.list',
                privilege: 'customer.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-contact-login-list',
        label: 'TopdataContactLoginSW6.contactList.module.title',
        color: '#37d046',
        icon: 'regular:user',
        path: 'topdata.contact.login.list',
        parent: 'sw-customer',
        position: 110,
    }],

    defaultSearchConfiguration,
});